<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="icon-loader"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.13" cx="6.34277" cy="6.34326" r="2" />
    <circle opacity="0.25" cx="4" cy="12" r="2" transform="rotate(90 4 12)" />
    <circle opacity="0.38" cx="6.34277" cy="17.6567" r="2" />
    <circle opacity="0.5" cx="12" cy="20" r="2" />
    <circle opacity="0.63" cx="17.6572" cy="17.6567" r="2" />
    <circle opacity="0.75" cx="20" cy="12" r="2" transform="rotate(90 20 12)" />
    <circle opacity="0.88" cx="17.6572" cy="6.34326" r="2" />
    <circle cx="12" cy="4" r="2" />
  </svg>
</template>

<style lang="scss" scoped>
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  .icon-loader {
    animation: rotation 2s infinite linear;
  }
</style>
